<template>
    <div>
        <label class="inline-block mb-2">
            <input class="align-middle" :checked="value" @input="$emit('input', $event.target.checked)" type="checkbox" />
            <span class="ml-2">{{ label }}</span>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                required: true,
                type: String,
            },

            value: {
                required: true,
            },
        }
    };
</script>
